import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Topbar, Alert } from "@components";
import { PUBLIC_ROUTE } from "@router/route.constants";
import {
  ButtonWrapper,
  DigitBox,
  RootContainer,
  Text,
  SpinWrapper,
  StyledInput,
  EmptyBox,
  EmptyText,
  WarningImage,
  MainContainer,
  Container,
  Box,
  ImageBox,
  Image,
  SmallText,
  Title,
  GrayText,
  TextWrapper,
  AccountInfo,
  Copy,
  QRCodeContainer,
  QRCodeText,
  QRCodeImage,
  Wrapper,
  SimpleButton,
  CopyContainer,
  DigitTextWrapper,
  DigitText,
  UploadText,
  ScreenShotBox,
  PalePurpleWrapper,
  RowFlex,
  ColFlex,
  BlackText,
  ChangeBtn,
  SSWarningText,
} from "./ProceedTopUp.style";
import { SHARE_TYPE } from "@constants/shareTypes";
import { Button, Spin, Image as AntImage, Avatar } from "antd";
import TermsConditions from "../TermsConditions/TermsConditions";
import { getFormattedNumber } from "@utils";
import { api } from "@api";
import OtpInput from "react-otp-input";
import ConfirmModal from "./ConfirmModal/ConfirmModal";
import SuccessModal from "./SuccessModal/SuccessModal";
import { PRIVATE_ROUTE } from "@router/route.constants";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { openAlert } from "@redux/app/appSlice";
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";
import { localStorage } from "@utils";
import BonusConfirmModal from "./BonusConfirmModal/BonusConfirmModal";
import "react-slideshow-image/dist/styles.css";
import ErrorModal from "./ErrorModal/ErrorModal";
import SimpleImageModal from "./SimpleImageModal/SimpleImageModal";
import { IMG_QR, CopyFill, GalleryIcon } from "@assets";
import FirstBonusConfirmModal from "./FirstBonusConfirmModal/FirstBonusConfirmModal";

// Create a function to download the image
function downloadImage(url) {
  // Create an anchor element to trigger the download
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.target = "_blank"; // Open in a new tab, if needed
  anchor.download = "ballone_gabar_qr.png"; // Specify the filename for download

  // Trigger a click event on the anchor element
  const event = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: true,
  });
  anchor.dispatchEvent(event);
}

const ProceedTopUp = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [loading, setLoading] = useState(true);
  const [receiving_account, setAccount] = useState({});
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [required, setRequired] = useState(false);
  const [trx_num, setTrxNum] = useState(null);
  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [has_bonus, setHasBonus] = useState(false);
  const [bonusOpen, setBonusOpen] = useState(false);
  const [qrPreview, setQrPreview] = useState(false);
  const [is_first_topup, setIsFirstTopup] = useState(false);
  const [bonusModalOpen, setBonusModalOpen] = useState(false);
  const [is_bonus_accepted, setBonusAccepted] = useState(0);
  const [bonus_percent, setBonusPercent] = useState(0);

  const userPreferedLanguage = localStorage.getUserPreferedLanguage();
  const {
    topup_rule,
    active_topup_screenshot
  } = useSelector((state) => state.app.settings);

  // let active_topup_screenshot = 1;

  const [simpleOpen, setSimpleOpen] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [canShare, setCanShare] = useState(0);
  const [isPromoUser, setIsPromoUser] = useState(false);

  // handle max toup bonus limit
  const [exceed_bonus_limit, setExceedBonusLimit] = useState(false);
  const [total_amount, setTotalAmount] = useState(0);
  const [max_topup_reward, setMaxTopupReward] = useState(0);

  const [imgUrl, setImgUrl] = useState('');
  const [uploadedImage, setUploadedImage] = useState('');

  const topupRule =
    userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK
      ? topup_rule?.text_en
      : userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK
        ? topup_rule?.text_mm
        : topup_rule?.text_ch;

  const payment_category_id = state?.account?.payment_category_id;
  const amount = state?.amount;

  let CODE_LENGTH = state?.account?.trx_num_digit;

  useEffect(() => {
    getSysPayment();

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    has_bonus && receiving_account && setBonusOpen(true);

    // eslint-disable-next-line
  }, [has_bonus]);

  useEffect(() => {
    is_first_topup && receiving_account && setBonusModalOpen(true);

    // eslint-disable-next-line
  }, [is_first_topup]);

  const getSysPayment = () => {
    setLoading(true);
    api
      .getSysPayment({
        payment_category_id,
        amount,
      })
      .then(({ sys_payment, has_bonus, is_first_topup, bonus_percent, is_registration_with_promocode, exceed_bonus_limit, total_amount, max_topup_reward }) => {
        setLoading(false);
        setAccount(sys_payment);
        if (!is_first_topup) {
          setHasBonus(has_bonus);
        }
        setIsFirstTopup(is_first_topup);
        setBonusPercent(bonus_percent);
        setIsPromoUser(is_registration_with_promocode);
        setExceedBonusLimit(exceed_bonus_limit);
        setTotalAmount(total_amount);
        setMaxTopupReward(max_topup_reward);
      })
      .catch((errorMsg) => {
        setErrorMessage(errorMsg);
        setOpenError(true);
      });
  };

  const handleConfirmClicked = () => {
    if (active_topup_screenshot) {
      navigate(`/${PRIVATE_ROUTE.CHECK_PAYMENT_DATA}`, {
        state: {
          selectedAmount: amount,
          receivingAccPh: receiving_account.num,
          // receivingAccName: receiving_account.name,
          selectedPaymentName: state.account.name,
          imgUrl: imgUrl,
          imgSize: uploadedImage.size,
          imgName: uploadedImage.name,
          codeLength: state?.account?.trx_num_digit,
          payment_category_id: payment_category_id,
          is_bonus_accepted: is_bonus_accepted,
        }
      })
    } else {
      if (!confirmLoading) {
        if (!trx_num || trx_num.length < CODE_LENGTH) {
          setRequired(true);
          return;
        }
        setRequired(false);
        setOpen(true);
      }
    }
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    const url = URL.createObjectURL(file);
    setUploadedImage(file);
    setImgUrl(url);
  };

  const confirm = () => {
    if (!confirmLoading) {
      setConfirmLoading(true);
      api
        .topup({
          amount,
          payment_category_id,
          trx_num,
          num: receiving_account.num,
          is_bonus_accepted,
        })
        .then(({ can_share }) => {
          setCanShare(can_share);
          setConfirmLoading(false);
          handleClose();
          setOpenSuccess(true);
        })
        .catch((errorMsg) => {
          setConfirmLoading(false);
          handleClose();
          showAlert({
            message: errorMsg,
            isError: true,
          });
        });
    }
  };

  const handleBonusClose = () => {
    setBonusOpen(false);
  };

  const handleBonusModalClose = () => {
    setBonusModalOpen(false);
  };

  const onBonusAccept = () => {
    setBonusOpen(false);
    setBonusModalOpen(false);
    setBonusAccepted(1);
  };

  const successCallback = () => {
    if (canShare === 1) {
      navigate(`/${PRIVATE_ROUTE.SHARE_LINK}/${SHARE_TYPE.TOPUP}`);
    } else {
      navigate(`/${PRIVATE_ROUTE.WALLET}`);
    }
  };

  const handleNumChange = (value) => {
    setTrxNum(value);
    setRequired(false);
  };

  const goBack = () => {
    navigate(-1);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onOk = () => {
    setErrorMessage("");
    setOpenError(false);
    navigate(-1);
  };

  const copy = () => {
    navigator.clipboard
      .writeText(receiving_account.num)
      .then(() => {
        showAlert({
          message: t("common.copied"),
        });
      })
      .catch((error) => {
        //create input or text area
        const input = document.createElement("input");
        input.setAttribute("value", receiving_account.num);
        document.body.appendChild(input);
        input.select();
        const result = document.execCommand("copy");
        document.body.removeChild(input);
        if (result) {
          showAlert({
            message: t("common.copied"),
          });
        } else {
          alert("Failed to copy to clipboard.");
        }

        console.error("Failed to copy: ", error);
      });
  };

  const download = () => {
    setDownloading(true);
    fetch(receiving_account.image, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    })
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        downloadImage(url);
        if (window.flutter_inappwebview?.callHandler) {
          window.flutter_inappwebview.callHandler(
            "onEvent",
            receiving_account?.image
          );
        }
        setDownloading(false);
        showAlert({
          message: t("wallet.downloadSuccessMsg"),
        });
      })
      .catch((_) => {
        setDownloading(false);
        showAlert({
          message: t("wallet.downloadFailedMsg"),
          isError: true,
        });
      });
  };

  const showAlert = (data) => {
    dispatch(openAlert(data));
  };

  const Loader = () => (
    <SpinWrapper>
      <Spin />
    </SpinWrapper>
  );

  const EmptyCard = () => (
    <div style={{ padding: "0 16px" }}>
      <EmptyBox>
        <WarningImage />
        <EmptyText>{t("common.notice")}</EmptyText>
        <EmptyText>{t("wallet.noTopUpAccountErrorMessage")}</EmptyText>
        <Button type="primary" onClick={() => navigate(-1)}>
          {t("common.ok")}
        </Button>
      </EmptyBox>
    </div>
  );

  if (!state) {
    return <Navigate to={`/${PUBLIC_ROUTE.HOME}`} />;
  }

  return (
    <>
      <MainContainer>
        <Topbar title={t("wallet.proceedTopUpTitle")} goBack={goBack} />
        {loading && <Loader />}
        {!loading && !receiving_account && <EmptyCard />}
        {!loading && receiving_account && (
          <RootContainer>
            <Container>
              <SmallText>{t("wallet.proceedTopUpTransferAmount")}</SmallText>
              <Title>
                {getFormattedNumber(state.amount)}
                &nbsp;
                <GrayText>Ks</GrayText>
              </Title>
              {receiving_account.image === null ? (
                <Box>
                  <ImageBox>
                    <Image src={state.account.image} />
                  </ImageBox>
                  <AccountInfo>
                    <Text id="name">{receiving_account.name}</Text>
                    <Text id="phone">{receiving_account.num}</Text>
                  </AccountInfo>
                  <CopyContainer onClick={copy}>
                    <CopyFill />
                    <Copy>{t("common.copy")}</Copy>
                  </CopyContainer>
                </Box>
              ) : (
                <QRCodeContainer>
                  <QRCodeImage />
                  <QRCodeText onClick={() => setQrPreview(true)}>
                    {t("wallet.viewQRCode")}
                  </QRCodeText>
                  <QRCodeText onClick={download}>
                    {downloading ? (
                      <Wrapper>
                        <Spin size="small" />
                      </Wrapper>
                    ) : (
                      <span>{t("wallet.downloadQR")}</span>
                    )}
                  </QRCodeText>
                </QRCodeContainer>
              )}
              <TextWrapper>
                {t("wallet.proceedTopUpWarningLabel1")}
                {t("wallet.proceedTopUpWarningLabel2")}
              </TextWrapper>
            </Container>

            {active_topup_screenshot ? (
              <ScreenShotBox>
                <Text>
                  {t("wallet.screenshot")}                   <SimpleButton onClick={() => setSimpleOpen(true)}>
                    {t("wallet.proceedTopUpViewSample")}
                  </SimpleButton>
                </Text>
                {
                  uploadedImage?.name ? (
                    <PalePurpleWrapper>
                      <RowFlex
                        style={{ gap: 14, width: '100%', justifyContent: "space-between" }}
                      >
                        <div
                          style={{ width: 52 }}
                        >
                          <Avatar
                            src={imgUrl}
                            size={52}
                            shape="square"
                          />
                        </div>

                        <ColFlex style={{ flex: 1 }}>
                          <BlackText
                            style={{ textOverflow: "ellipsis", display: 'block' }}
                          > {`${uploadedImage.name.substring(0, 15)}...`} </BlackText>
                          <GrayText> {`${uploadedImage.size / 1000} kb`} </GrayText>
                        </ColFlex>
                        <label htmlFor="fileInput">
                          <ChangeBtn>
                            {t("wallet.change")}
                          </ChangeBtn>
                        </label>
                        {/* Invisible file input */}
                        <input
                          id="fileInput"
                          type="file"
                          accept="image/*"
                          onChange={handleImageUpload}
                          style={{ display: 'none' }}
                        />
                      </RowFlex>
                    </PalePurpleWrapper>
                  ) : (
                    <>
                      <label htmlFor="fileInput">
                        <PalePurpleWrapper
                          style={{ cursor: 'pointer' }}
                        >
                          <GalleryIcon />
                          <UploadText> {t("wallet.uploadScreenshot")} </UploadText>
                          <SSWarningText>
                            {t("wallet.screenshotWarningMsg")}
                          </SSWarningText>
                        </PalePurpleWrapper>
                      </label>

                      {/* Invisible file input */}
                      <input
                        id="fileInput"
                        type="file"
                        accept="image/*"
                        onChange={handleImageUpload}
                        style={{ display: 'none' }}
                      />
                    </>
                  )
                }
                <ButtonWrapper>
                  <Button
                    type="primary"
                    size="large"
                    onClick={handleConfirmClicked}
                    disabled={!imgUrl}
                  >
                    {t("common.confirm")}
                  </Button>
                </ButtonWrapper>
              </ScreenShotBox>
            ) : (
              <DigitBox>
                <DigitTextWrapper>
                  <DigitText>{t("wallet.proceedTopUpLast8Digits", { num: CODE_LENGTH })}</DigitText>
                  <SimpleButton onClick={() => setSimpleOpen(true)}>
                    {t("wallet.proceedTopUpViewSample")}
                  </SimpleButton>
                </DigitTextWrapper>
                <OtpInput
                  value={trx_num}
                  onChange={handleNumChange}
                  inputType={"number"}
                  numInputs={CODE_LENGTH}
                  renderInput={(props, index) => (
                    <StyledInput
                      status={required ? "error" : "default"}
                      autoFocus={index === 0}
                      {...props}
                    />
                  )}
                  containerStyle="otp-length-8"
                />

                <ButtonWrapper>
                  <Button
                    type="primary"
                    size="large"
                    onClick={handleConfirmClicked}
                  >
                    {t("common.continue")}
                  </Button>
                </ButtonWrapper>
              </DigitBox>
            )
            }

            <TermsConditions
              title={t("wallet.proceedTopUpTerms")}
              rule={topupRule}
            />
          </RootContainer>
        )}

        <SimpleImageModal
          active_topup_screenshot={active_topup_screenshot}
          receiving_account={receiving_account}
          open={simpleOpen}
          onOk={() => setSimpleOpen(false)}
        />

        <ConfirmModal
          open={open}
          loading={confirmLoading}
          handleClose={handleClose}
          onConfirm={confirm}
        />
        <BonusConfirmModal
          open={bonusOpen}
          handleClose={handleBonusClose}
          onBonusAccept={onBonusAccept}
          bonus_percent={bonus_percent}
          amount={amount}
          exceed_bonus_limit={exceed_bonus_limit}
          total_amount={total_amount}
          max_topup_reward={max_topup_reward}
        />
        <FirstBonusConfirmModal
          exceed_bonus_limit={exceed_bonus_limit}
          total_amount={total_amount}
          max_topup_reward={max_topup_reward}
          amount={amount}
          bonus_percent={bonus_percent}
          isPromoUser={isPromoUser}
          open={bonusModalOpen}
          handleClose={handleBonusModalClose}
          onBonusAccept={onBonusAccept}
        />
        <SuccessModal open={openSuccess} onOk={successCallback} />
        <ErrorModal open={openError} message={errorMessage} onOk={onOk} />
        <Alert />
      </MainContainer>
      <AntImage
        width="100%"
        style={{ display: "none" }}
        src={IMG_QR}
        preview={{
          visible: qrPreview,
          src: receiving_account?.image,
          scaleStep: 0.5,
          onVisibleChange: (value) => {
            setQrPreview(value);
          },
        }}
      />
    </>
  );
};

export default ProceedTopUp;
